import { Injector } from '@angular/core';

export class DynamicFilterOptions {

   Pessoa = {
      model: Object,
      service: null
   };

   constructor(
      protected _injector: Injector,
   ) {
      // this.Pessoa.service = _injector.get(PessoaService);
   }

}
